import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { Event, EventId } from './event.model'

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private subject = new Subject<Event>()

  publish = <T = any>(event: Event<T>) => {
    this.subject.next(event)
  }

  observe = <T = any>(...eventId: EventId[]) => {
    return this.subject
      .asObservable()
      .pipe(filter((event) => eventId.includes(event.id)))
      .pipe(map((event) => event as Event<T>))
  }
}
